import { createApp } from 'vue'
import App from '@/App.vue'

// noinspection JSUnusedLocalSymbols
let app = createApp(App)
  .mount('#app')
